import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { identifyUser } from './identifyUser';
import { initMonitoring } from './initMonitoring';
import { isMonitoringEnabled } from './isMonitoringEnabled';

export { identifyUser, initMonitoring, isMonitoringEnabled };

const originalDatadogError = datadogLogs.logger.error.bind(datadogLogs.logger);

export const logger = Object.assign(datadogLogs.logger, {
  error: (message: string, error: unknown | Error, context?: Record<string, unknown>) => {
    if (error instanceof Error) {
      originalDatadogError(message, context, error);
      return;
    }
    originalDatadogError(message, context, new Error(message, { cause: error }));
  },
});
export const addError = datadogRum.addError;
